// @flow

import * as React from 'react';

import { useCartWidgetSuggestions } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import ProductSuggestionItem from './components/ProductSuggestionItem';

export default function Suggestions(): React.MixedElement | null {
  const { __ } = useTranslator();
  const { suggestions: allSuggestions } = useCartWidgetSuggestions();

  const suggestions = allSuggestions?.slice(0, 2);

  if (!suggestions?.length) {
    return null;
  }

  return (
    <div>
      <Base tagName="h3" size="base" marginBottom="small">
        {__('You also may like')}
      </Base>
      <Base
        flex
        flexAlignItemsStart
        flexColToRow
        gap="small"
        marginBottom="small"
      >
        {suggestions.map(suggestion => (
          <ProductSuggestionItem
            suggestion={suggestion}
            key={suggestion.suggestionId}
          />
        ))}
      </Base>
    </div>
  );
}
